import { URL } from "../const/infoConst";


//正式服隐藏log日志
export const meshLog = (...info) => {
    if (urlDebug()) {
        console.log(...info);
    }
}


//本地存储
export const SPRemove = (key) => {
    key = msgReverse(key);
    localStorage.removeItem(key);
}


export const SPSet = (key, value) => {
    if (msgNeedEncrypt(key)) {
        
    }
    key = msgReverse(key);
    localStorage.setItem(key, value);
}

export const SPGet = (key) => {
    let data = localStorage.getItem(msgReverse(key));
    if (msgNeedEncrypt(key)) {

    }
    return data;
}






function urlDebug() {
    if (URL.substring(0, 4) == 'http') {
        return true;
    }
    return false;
}

function msgNeedEncrypt(msg) {
    if (!urlDebug()) {  //!urlDebug()
        if (msg == 'encrypt') {
            return true;
        }
    }
    return false;
}

function msgReverse(msg) {
    if (!urlDebug()) {  


    }
    return msg;
}
